import * as Actions from "../action/claimManagement";

const initialState = {
    modeGestionData: [], 
    loadinge :true
};
 
const modeGestionReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ALL_SERVICE_TYPE_SUCCESS: {
      return {
        ...state,
        modeGestionData: action.payload, 
        loadinge :false,
      };
    }
 

    default:
      return state;
  }
};
export default modeGestionReducer;